<template>
  <div>
    <v-navigation-drawer disable-resize-watcher v-model="drawer" temporary app width="300">
      <v-list-item link>
        <v-list-item-avatar>
          <v-icon large>mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list>
        <template v-for="(link, i) in links">
          <v-list-group v-if="link.children && userRole(link)" :key="i" :prepend-icon="link.icon" active-class="dark-blue--text text--accent-4" >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title >{{ link.text }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <div v-for="(lk) in link.children" :key="lk.text">
              <v-list-item v-if="userRole(lk)" active-class="blue--text" router :to="lk.to" >
                <v-list-item-action>
                  <v-icon class="black--text" right>{{ lk.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle class="black--text">{{ lk.text }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list-group>
          <v-list-item v-if="!link.children && userRole(link)" active-class="blue--text" :key="i" router :to="link.to" >
            <v-list-item-action v-if="link.icon">
              <v-icon class="black--text" right>{{ link.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { drawer } from "@/router/links";
export default {
  data() {
    return {
      links: drawer
    };
  },
  computed: {
    drawer: {
      get() {
        return this.$store.getters["App/getDrawer"];
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    ...mapState({
      user: state => state.User.user
    })
  },
  methods: {
    userRole(link) {
      if (this.user && link.roles && link.roles.includes(this.user.role.name)) {
        return true;
      } else {
        return false;
      }
    },
    ...mapMutations({
      setDrawer: "App/setDrawer"
    }),
  }
};
</script>